import { inject, Injectable, Type } from '@angular/core';

import { TASK_SUMMARY_RENDERERS } from '../contracts/task-summary.contract';
import { TaskType } from '../models/task.interface';

@Injectable()
export class TaskSummaryRegistry {
  private readonly componentsByType = new Map<TaskType, Type<unknown>>();

  constructor() {
    const renderers = inject(TASK_SUMMARY_RENDERERS, { optional: true }) ?? [];
    for (const renderer of renderers) {
      this.componentsByType.set(renderer.type, renderer.component);
    }
  }

  componentFor(type: TaskType): Type<unknown> | null {
    return this.componentsByType.get(type) ?? null;
  }
}
